import { gql } from "@apollo/client"

const GET_PAGE_BY_ROUTE = gql`
  query GetPageByRoute($route: String!, $culture: String) {
    page: contentByAbsoluteRoute(route: $route, culture: $culture) {
      url
      absoluteUrl
      level
      parent {
        id
        url
        level
        properties {
          propertyName: alias
          propertyValue: value {
            ...propertyValuesRoute
          }
        }
        parent {
          id
          url
          level
          properties {
            propertyName: alias
            propertyValue: value {
              ...propertyValuesRoute
            }
          }
          parent {
            id
            url
            level
            properties {
              propertyName: alias
              propertyValue: value {
                ...propertyValuesRoute
              }
            }
            parent {
              id
              url
              level
              properties {
                propertyName: alias
                propertyValue: value {
                  ...propertyValuesRoute
                }
              }
            }
          }
        }
      }
      contentType {
        alias
      }
      children {
        name
        url
        id
        contentType {
          alias
        }
        properties {
          propertyName: alias
          propertyValue: value {
            ...propertyValuesRoute
          }
        }
      }
      properties {
        propertyName: alias
        propertyValue: value {
          ...propertyValuesRoute
        }
      }
    }
  }
  fragment propertyEditorsRoute on PropertyValue {
    ...basicValue
    ...contentPicker
    ...dateTimePicker
    ...label
    ...mediaPicker
    ...memberPickerRoute
    ...multiUrlPicker
    ...nestedContentRoute
    ...richTextEditor
    ...unsupportedEditor
    valueType: model
  }

  fragment dateTimePicker on PropertyValue {
    ... on BasicDateTimePicker {
      dateTime: value
    }
  }

  fragment basicValue on PropertyValue {
    ... on BasicPropertyValue {
      value: value
    }
  }

  fragment contentPicker on PropertyValue {
    ... on BasicContentPicker {
      contentList {
        id
        absoluteUrl
        key
        name
        url
        urlSegment
      }
    }
  }

  fragment label on PropertyValue {
    ... on BasicLabel {
      label: value
    }
  }

  fragment mediaPicker on PropertyValue {
    ... on MintMediaPicker {
      mediaItems {
        id
        url
        altText
      }
    }
  }

  fragment memberPickerRoute on PropertyValue {
    ... on BasicMemberPicker {
      members {
        id
        name
        properties {
          alias
          value {
            ...memberPropertyEditorsRoute
          }
          editorAlias
        }
      }
    }
  }

  fragment memberPropertyEditorsRoute on PropertyValue {
    ...basicValue
    ...contentPicker
    ...dateTimePicker
    ...label
    ...mediaPicker
    ...slimMemberPicker
    ...multiUrlPicker
    ...nestedContentRoute
    ...richTextEditor
    ...unsupportedEditor
    model
  }

  fragment slimMemberPicker on PropertyValue {
    ... on BasicMemberPicker {
      members {
        id
        name
      }
    }
  }

  fragment multiUrlPicker on PropertyValue {
    ... on BasicMultiUrlPicker {
      links {
        name
        target
        type
        url
      }
    }
  }

  fragment nestedContentRoute on PropertyValue {
    ... on BasicNestedContent {
      elements {
        properties {
          alias
          value {
            ...nestedContentPropertyEditors
          }
          editorAlias
        }
      }
    }
  }

  fragment nestedContentPropertyEditors on PropertyValue {
    ...basicValue
    ...contentPicker
    ...dateTimePicker
    ...label
    ...mediaPicker
    ...slimMemberPicker
    ...multiUrlPicker
    ...richTextEditor
    ...unsupportedEditor
    model
  }

  fragment richTextEditor on PropertyValue {
    ... on BasicRichText {
      richText: value
      #sourceValue
    }
  }

  fragment unsupportedEditor on PropertyValue {
    ... on BasicUnsupportedPropertyValue {
      message
    }
  }

  fragment blockEditorRoute on PropertyValue {
    ... on BasicBlockListModel {
      blocks {
        blockType: contentAlias
        #settingsAlias
        properties: contentProperties {
          propertyName: alias
          #editorAlias
          propertyValue: value {
            ...propertyEditorsRoute
            ... on BasicBlockListModel {
              blocks {
                blockType: contentAlias
                properties: contentProperties {
                  propertyName: alias
                  #editorAlias
                  propertyValue: value {
                    ...propertyEditorsRoute
                    ... on BasicBlockListModel {
                      blocks {
                        blockType: contentAlias
                        properties: contentProperties {
                          propertyName: alias
                          #editorAlias
                          propertyValue: value {
                            ...propertyEditorsRoute
                            ... on BasicBlockListModel {
                              blocks {
                                blockType: contentAlias
                                properties: contentProperties {
                                  propertyName: alias
                                  #editorAlias
                                  propertyValue: value {
                                    ...propertyEditorsRoute
                                    ... on BasicBlockListModel {
                                      blocks {
                                        blockType: contentAlias
                                        properties: contentProperties {
                                          propertyName: alias
                                          #editorAlias
                                          propertyValue: value {
                                            ...propertyEditorsRoute
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  fragment blockGridEditorRoute on PropertyValue {
    ... on BasicBlockGridModel {
      gridColumns
      blocks {
        contentProperties {
          value {
            ...propertyEditorsRoute
          }
        }
        settingsProperties {
          value {
            ...propertyEditorsRoute
          }
        }
        columnSpan
        rowSpan
        areas {
          alias
          rowSpan
          columnSpan
          blocks {
            contentProperties {
              value {
                ...propertyEditorsRoute
              }
            }
            settingsProperties {
              value {
                ...propertyEditorsRoute
              }
            }
            columnSpan
            rowSpan
            areas {
              alias
              rowSpan
              columnSpan
            }
          }
        }
      }
    }
  }

  fragment propertyValuesRoute on PropertyValue {
    ...propertyEditorsRoute
    ...blockEditorRoute
    ...blockGridEditorRoute
  }
`

export default GET_PAGE_BY_ROUTE
